/**
 * Volume Weighted Average Price (VWAP)
 *
 * Intraday benchmark: average price weighted by volume, reset each session.
 * Typically used on intraday charts; meaningful on 1-min to 30-min timeframes.
 *
 * Category: Trend | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const vwapIndicator: IndicatorDefinition = {
  id: "vwap",
  name: "Volume Weighted Average Price",
  shortName: "VWAP",
  category: "trend",
  pane: "overlay",
  params: [
    { key: "color", label: "Color", type: "color", default: "#AA00FF" },
  ],
  plots: [
    { key: "vwap", label: "VWAP", color: "#AA00FF", style: "line", lineWidth: 2 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const data: { time: number; value: number }[] = [];
    let cumTypicalVolume = 0;
    let cumVolume = 0;
    let lastDay = -1;

    for (const c of candles) {
      // Reset at day boundary (detect via date change)
      const day = Math.floor(c.time / 86400);
      if (day !== lastDay) {
        cumTypicalVolume = 0;
        cumVolume = 0;
        lastDay = day;
      }

      const typicalPrice = (c.high + c.low + c.close) / 3;
      cumTypicalVolume += typicalPrice * (c.volume || 1);
      cumVolume += c.volume || 1;

      data.push({ time: c.time, value: cumTypicalVolume / cumVolume });
    }
    return [{ key: "vwap", data }];
  },
};
